module.exports = __webpack_public_path__ + "static/thank-you-multilanguage-b9471128e317b144b860e6e58c485de0.png";